// #region imports

// --- Angular
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

// --- RxJs
import { Subscription, interval } from 'rxjs';

// --- HS Code
import { Constants } from '../../../models';

// #endregion

@Component({
  selector: 'hs-undo-snack-bar',
  templateUrl: './undo-snack-bar.component.html',
  styleUrls: ['./undo-snack-bar.component.scss'],
  animations: [
    trigger('flyIn', [
      transition(':enter', [
        style({bottom: '-100px'}),
        animate(200, style({bottom: '0'}))
      ]),
      transition(':leave', [
        animate(200, style({bottom: '-100px'}))
      ])
    ])
  ]
})
export class UndoSnackBarComponent implements OnDestroy, OnChanges {

  @Input() alertText: string = '';
  @Input() show: boolean = false;

  @Output() textClick = new EventEmitter();
  @Output() alertExpired = new EventEmitter();

  countdownValue: number = 100;

  private _timeSubscription: Subscription = Subscription.EMPTY;

  ngOnDestroy(): void {
    this._stopTimer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['alertText'] && changes['alertText'].currentValue) {
      this.countdownValue = 100;
      this._stopTimer();
      this._startTimer(Constants.UNDO_DELETE_COUNTDOWN_MAX_IN_SECONDS);
    }
  }

  onTextClicked(): void {
    this._stopTimer();
    this.show = false;
    this.textClick.emit();
  }

  private _startTimer(seconds: number) {
    const timer$ = interval(100);

    this._timeSubscription = timer$.subscribe((sec) => {
      this.countdownValue = 100 - sec * 100 / (seconds * 10);

      if (sec > (seconds * 10)) {
        this._timeSubscription.unsubscribe();
        this.show = false;
        this.alertExpired.emit();
      }
    });
  }

  private _stopTimer(): void {
    if (this._timeSubscription !== Subscription.EMPTY) {
      this._timeSubscription.unsubscribe();
      this._timeSubscription = Subscription.EMPTY;
    }
  }
}
